import { EntidadeBase } from 'hay-core-react';
import { ApiService } from 'hay-core-react';
class GrupoModel extends EntidadeBase {
    constructor() {
        super('grupo');
    }

    async sincronizarPermissoes() {
        return ApiService.post('/grupo/sincronizarpermissoes');
    }
}

const instance = new GrupoModel();
export default instance;
